import { h as head, b as attr, p as pop, a as push } from "../../../../chunks/index2.js";
import "@sveltejs/kit/internal";
import "../../../../chunks/exports.js";
import "../../../../chunks/utils.js";
import "../../../../chunks/state.svelte.js";
import { g as getToastState } from "../../../../chunks/Toast.svelte.js";
function _page($$payload, $$props) {
  push();
  getToastState();
  const { form } = $$props;
  let email = form?.data?.email;
  let loading = false;
  head($$payload, ($$payload2) => {
    $$payload2.title = `<title>Forgot Password</title>`;
  });
  $$payload.out.push(`<h2 class="text-center text-2xl font-bold">Forgot Password</h2> <span class="text-primary mt-4 text-xs hover:underline"><a href="/login">Back to login</a></span> <form method="POST" class="mt-4">`);
  {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--> <div class="mb-4"><label for="email" class="block text-sm font-semibold">Email</label> <input type="email" id="email" name="email" class="w-full rounded-md border p-2"${attr("value", email)}/></div> <button type="submit" class="group bg-primary hover:bg-primary/90 flex w-full items-center justify-center rounded-md border p-2 text-white transition-colors hover:cursor-pointer"${attr("disabled", loading, true)}>`);
  {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--> Reset Password</button></form>`);
  pop();
}
export {
  _page as default
};
